module.exports = __webpack_public_path__ + "static/img/house2-thumb.1d68d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/house2-thumb.jpg
// module id = BDkY
// module chunks = 0